'use client';

import React from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/system/styleFunctionSx';
import { JucySlider } from '@jucy-ui/components/JucySlider';
import { BlockContainer } from '@/components/Blocks/BlockContainer';
import { BlockTitle } from '@/components/Blocks/components/BlockTitle';
import { CmsHtmlContent } from '@/components/CmsHtmlContent';
import analytics from '@/services/analytics';
import { CmsTestimonialsBlock } from '@/services/cms/blocks/CmsTestimonialsBlock';

interface TestimonialsBlockProps extends CmsTestimonialsBlock {
    sx?: SxProps<Theme>;
}

export const TestimonialsBlock = ({ sx, ...props }: TestimonialsBlockProps) => (
    <BlockContainer sx={sx} {...props}>
        <BlockTitle {...props} />
        <CmsHtmlContent html={props.content} />
        <Container
            maxWidth="md"
            onMouseOver={() => {
                analytics.track('review_engagement', {
                    location: window.location.toString(),
                });
            }}
        >
            <JucySlider adaptiveHeight={true} showDots={false} showNav={true} config={{ all: { slidesToShow: 1 } }}>
                {props.testimonials?.map((testimonial, i) => (
                    <Box
                        data-index={i}
                        key={`testimonial-card-${testimonial.id}`}
                        sx={{
                            px: 4,
                            py: 1.5,
                            bgcolor: 'background.light',
                        }}
                    >
                        {testimonial.comment}
                        {testimonial.author ? (
                            <Stack
                                direction="row"
                                sx={{
                                    gap: 2,
                                    mt: 3,
                                }}
                            >
                                <AccountCircleIcon color="primary" fontSize="large" sx={{ width: 40, height: 40 }} />
                                <Box>
                                    {testimonial.author}
                                    <Typography variant="caption" sx={{ display: 'block' }}>
                                        {testimonial.location}
                                    </Typography>
                                </Box>
                            </Stack>
                        ) : null}
                    </Box>
                ))}
            </JucySlider>
        </Container>
    </BlockContainer>
);
